export const limitDate = (value) => {
    value = value.replaceAll('-', '')

    if (value >= '19700101' && value <= '20501231') {
        return true;
    }
    return false;
    
}